import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useViewport } from 'components/templates/viewportProvider';
import squirrelIcon from 'assets/images/squirrel.mascot-icon-01.svg';
import { ShareButton } from 'components/atoms/shareButton';
import { ShareModal } from 'components/templates/shareModal';
//eslint-disable-next-line
import styles from "./styles.scss";

export const FullPage = props => {
  const { isMobile } = useViewport();
  const { componentList, updateTheme, showShareButton } = props;

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  return (
    <Row>
      <Col>
        <div>
          <div id={'fullpage-wrapper'}>
            {componentList.length &&
              componentList.map((component, index) => {
                const disableSection = component.sectionName
                  ? component.sectionName
                  : '';
                return (
                  <Row className={component.theme}>
                    <Col xs={1} sm={1} md={1} id={'sidenav-menu'} />
                    <Col xs={12} sm={11} md={11} className={'fullpage-section'}>
                      <div
                        className={`section ${disableSection}`}
                        key={index}
                        data-anchor={component.sectionId || 'sec' + index}
                      >
                        <component.component
                          breadcrumbList={component.breadcrumbList}
                          data={component.data}
                          loading={component.loading}
                          location={component.location}
                          theme={component.theme}
                          mobileBannerData={component.mobileBannerData}
                          origin={component.origin}
                          updateTheme={updateTheme}
                        />
                      </div>
                    </Col>
                  </Row>
                );
              })}
            <div className={'squirrel-te-icon'}>
              <img
                className={'squirrel-icon'}
                src={squirrelIcon}
                alt={'logo'}
              />
            </div>
            {isMobile && showShareButton && (
              <ShareButton
                onClick={() => setIsShareModalOpen(true)}
                mode={'dark'}
                shareButtonClassName={'share-btn'}
              />
            )}
            <ShareModal
              isOpen={isShareModalOpen}
              onClosePress={closeShareModal}
              callPostLeadAPI={true}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};
